module.exports = __webpack_public_path__ + "media/images/flags/vi-370f5f4e9a59ad970a960e8b18c02458.svg";